var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-arrow-up-down-icon lucide-arrow-up-down",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21 16-4 4-4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20V4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m3 8 4-4 4 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4v16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdown);
export default __webpack_public_path__ + "static/media/updown.207f7330ec8e7970d537b6dfbae7317f.svg";
export { ForwardRef as ReactComponent };